import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://api.kewaar.com/api' : '/api',
  headers: {
    'Content-Type': 'application/json'
  }
})

export function getBreathingExercises() {
  return apiClient.get('/sleeps/breathing/saudi')
}

let lastRequestTime = 0
const MIN_REQUEST_INTERVAL = 2000 // 2 seconds between requests

export async function addToWaitlist(data) {
  // Prevent double submissions
  const now = Date.now()
  if (now - lastRequestTime < MIN_REQUEST_INTERVAL) {
    throw new Error('Please wait a moment before submitting again')
  }
  lastRequestTime = now

  // Get user's IP address
  let ipAddress = ''
  try {
    const ipResponse = await fetch('https://api.ipify.org?format=json')
    const ipData = await ipResponse.json()
    ipAddress = ipData.ip
  } catch (err) {
    console.error('Failed to get IP:', err)
  }

  return apiClient.post('/waitlist', {
    email: data.email,
    event_name: 'saudifeb2026',
    name: data.name || '',
    ip_address: ipAddress,
    source: 'androidpage',
    phone: data.phone || '',
    company: data.company || '',
    priority: data.priority || 1,
    notes: data.notes || '',
    tags: data.tags || [],
    utm_campaign: data.utm_campaign || '',
    utm_source: data.utm_source || 'androidpage',
    utm_medium: data.utm_medium || ''
  }, {
    headers: {
      'Accept': 'application/json'
    }
  })
}

export async function addToMonthlyPromo(data) {
  // Prevent double submissions
  const now = Date.now()
  if (now - lastRequestTime < MIN_REQUEST_INTERVAL) {
    throw new Error('Please wait a moment before submitting again')
  }
  lastRequestTime = now

  // Get user's IP address
  let ipAddress = ''
  try {
    const ipResponse = await fetch('https://api.ipify.org?format=json')
    const ipData = await ipResponse.json()
    ipAddress = ipData.ip
  } catch (err) {
    console.error('Failed to get IP:', err)
  }

  return apiClient.post('/saudi-promo', {
    email: data.email,
    event_name: 'saudifeb2026',
    name: data.name || '',
    ip_address: ipAddress,
    source: 'monthlypromo',
    phone: data.phone || '',
    company: data.company || '',
    priority: data.priority || 1,
    notes: data.notes || '',
    tags: data.tags || [],
    utm_campaign: data.utm_campaign || '',
    utm_source: data.utm_source || 'monthlypromo',
    utm_medium: data.utm_medium || ''
  }, {
    headers: {
      'Accept': 'application/json'
    }
  })
}
